const angular = require('angular');
/**
 * Directive For select multiple cell in table component
 * Author: Rizwan Kukad
 * 
 */
export default angular.module('nodeApp.multiCellSelect', [])
    .directive('multiCellSelect', ['$window', '$document', function ($window, $document) {

        return {
            scope: {
                multiCellIds: '=',
                resetCells: '=',
                columnsWidth: '=',
                selectedRows: '=',
                selectedColumns: '=',
                selectAll: '='
            },

            link: function (scope, element, attrs) {
                scope.$watch('resetCells', function () {
                    element.find(".eng-selected-item").removeClass("eng-selected-item");
                    scope.multiCellIds = [];
                    scope.resetCells = false;
                });


                setTimeout(function () {
                    element.find('td')
                        .resizable({
                            resizeHeight: false,
                            // we use the column as handle and filter
                            // by the contained .resizer element
                            handleSelector: "> .resizer",
                            onDragStart: function (e, $el, opt) {
                                // only drag resizer
                                if (!$(e.target).hasClass("resizer")) {
                                    return false;
                                }
                                return true;
                            },
                            onDragEnd: function (e, $el, opt) {

                            },
                            onDrag: function (e, $el, newWidth, newHeight, opt) {
                                //console.log($el.find('div.column'));
                                var column = parseInt($el.prop('id').split('-')[1], 10);
                                scope.columnsWidth[column] = newWidth;

                                //$el.find('div.column').width(newWidth);

                                // explicitly return **false** if you don't want 
                                // auto-height computation to occur
                                return true;
                            }
                        });
                });
            },

            /**
             * Directive Controller Function
             *
             * @param      {<type>}  $scope    The scope
             * @param      {<type>}  $element  The element
             * @return     {Object}
             */
            controller: ['$scope', '$element', '$window', '$document', function ($scope, $element, $window, $document) {
                var clearFlag = false;
                var startCell = null;
                var dragging = false;
                var finalCell = null;
                var flag = false;

                /**
                 * MouseDown Event Callback
                 *
                 * @param      {<type>}  el      { DOM element }
                 */
                function mouseDown(el) {
                    if(!flag){
                        flag = true;
                        if(!startCell){
                            setStartCell(el);
                        }
                        dragging = true;
                        setStartCell(el);
                        setRangeArea(startCell, el);
                    }
                }

                /**
                 * MouseUp Event Callback
                 *
                 * @param      {<type>}  el      { DOM element }
                 */
               function mouseUp(el) {    
                    if(flag){
                    dragging = false;
                    finalCell = el;
                    setSelectedCells(startCell, finalCell)
                    if (clearFlag) {
                        clearCells(startCell, finalCell);
                        clearFlag = false;
                    }
                    
                    }
                    flag = false
                    setStartCell(null);
                }

                /**
                 * MouseLeave Event Callback
                 *
                 * @param      {<type>}  el      { DOM element }
                 */
                function mouseLeave(el) {
                    if (dragging) {
                        if (el.hasClass('hover-area')) {
                            var cellsObj = cellsBetween(startCell, el);
                            if(cellsObj){
                                cellsObj.each(function () {
                                    var el = angular.element(this);
                                    el.toggleClass('hover-area').addClass('ui-state-default')
                            });}
                            if (startCell == el) {
                                el.toggleClass('hover-area').addClass('ui-state-default')
                            }
                        }
                    } else {
                        return;
                    }
                }

                /**
                 * MouseEnter Event Callback
                 *
                 * @param      {<type>}  el      { DOM element }
                 */
                function mouseEnter(el) {
                    if (dragging) {
                        setRangeArea(startCell, el);
                    } else {
                        return;
                    }
                }

                /**
                 * Sets the start cell element.
                 *
                 * @param      {<type>}  el      { DOM element }
                 */
                function setStartCell(el) {
                    startCell = el;
                }

                /**
                 * Sets the range area.
                 *
                 * @param      {<type>}  start   The start
                 * @param      {<type>}  el      { DOM element }
                 */
                function setRangeArea(start, el) {
                    if(start[0] && el[0]){
                        var cellsObj = cellsBetween(startCell, el);
                        if (dragging  && cellsObj){
                            if (el.hasClass('ui-state-default')) {
                                cellsObj.each(function () {
                                    var el = angular.element(this);
                                    el.addClass('hover-area')
                                });
                            } else if (el.hasClass('hover-area') || el.hasClass('ui-state-default')) {
                            cellsObj.each(function () {
                                var el = angular.element(this);
                                el.toggleClass('hover-area').addClass('ui-state-default');
                            });
                            }

                            if (!start.hasClass('eng-selected-item')) {
                                cellsObj.each(function () {
                                    var el = angular.element(this);
                                    if (el.hasClass('eng-selected-item')) {
                                        clearFlag = true;
                                    }
                            });
                            }

                        }
                    }
                }

                /**
                 * Sets the selected cells.
                 *
                 * @param      {<type>}  start   The start
                 * @param      {<type>}  end     The end
                 */
                function setSelectedCells(start, end) {
                    if(start[0] && end[0]){
                    var cellsObj = cellsBetween(start, end); //jQuery object
                    if (cellsObj){
                        cellsObj.each(function () {
                            var el = angular.element(this);
                            if (el.hasClass('eng-selected-item')) {
                                el.removeClass('eng-selected-item');
                                if (el.hasClass('hover-area')){
                                el.removeClass('hover-area');}
                                var id = el.attr('id');
                                var index = $scope.multiCellIds.indexOf(id);
                                if ($scope.multiCellIds.indexOf(el.attr('id')) > -1) {
                                    $scope.multiCellIds.splice(index, 1);
                                }
                            } else if (!el.hasClass('eng-selected-item')) {
                                el.addClass('eng-selected-item');
                                if (el.hasClass('hover-area')){
                                el.removeClass('hover-area');}

                                if ($scope.multiCellIds.indexOf(el.attr('id')) == -1 && el.is(':visible')) {
                                    $scope.multiCellIds.push(el.attr('id'));
                                }
                            }
                        });
                    }
                    }
                }

                /**
                 * Clear Cells between given start/end
                 *
                 * @param      {<type>}  start   The start
                 * @param      {<type>}  end     The end
                 */
                function clearCells(start, end) {
                    if(start[0] && end[0]){
                        var cellsObj = cellsBetween(start, end);
                        if(cellsObj){
                        cellsObj.each(function () {
                            var el = angular.element(this);
                            el.removeClass('eng-selected-item');
                            el.removeClass('hover-area');
                            var id = el.attr('id');
                            var index = $scope.multiCellIds.indexOf(id);
                            if ($scope.multiCellIds.indexOf(el.attr('id')) > -1) {
                                $scope.multiCellIds.splice(index, 1);
                            }
                        });}
                    }
                }

                /**
                 * Calculate and return cells between range
                 *
                 * @param      {<type>}  start   The start
                 * @param      {<type>}  end     The end
                 * @return     {<Object>}  
                 */
                function cellsBetween(start, end) {
                    var coordsStart = getCoords(start);
                    var coordsEnd = getCoords(end);
                    var topLeft = {
                        column: $window.Math.min(coordsStart.column, coordsEnd.column),
                        row: $window.Math.min(coordsStart.row, coordsEnd.row),
                    };
                    var bottomRight = {
                        column: $window.Math.max(coordsStart.column, coordsEnd.column),
                        row: $window.Math.max(coordsStart.row, coordsEnd.row),
                    };
                    var ele = $element.find('tr td').not($element.find('table tr td'));
                   
                   if(ele[0].parentElement.parentElement==start[0].parentElement.parentElement){
                        ele = ele.filter(function () {
                            var el = angular.element(this);
                            var coords = getCoords(el);
                            return coords.column >= topLeft.column && coords.column <= bottomRight.column && coords.row >= topLeft.row && coords.row <= bottomRight.row;
                        });
                    return ele;
                    }else{
                        return null;
                    }
                    
                }

                /**
                 * Gets the coordinates.
                 *
                 * @param      {<type>}  cell    The cell
                 * @return     {Object}  The coordinates.
                 */
                function getCoords(cell) {
                   return {
                        column: cell[0].cellIndex,
                        row: cell[0].parentElement.rowIndex
                    }; 
                }

                function rowClick(el) {
                    var row = parseInt(el.attr('row-id'), 10),
                        rowSelected = el.attr('row-selected');
                        
                        var objTr = $element.find('tr')
                        objTr.each((x)=>{
                            if(objTr[x].firstElementChild == el[0].parentElement){
                                if (rowSelected === "true") {
                                    el.attr('row-selected', false);
                                    let rowIndex = $scope.selectedRows.indexOf(row);
                                    $scope.selectedRows.splice(rowIndex, 1);
                                } else {
                                    el.attr('row-selected', true);
                                    $scope.selectedRows.push(row);
                                }
                                //setRangeArea(objTr[x].firstElementChild, objTr[x].lastElementChild);
                                var start = {'0': objTr[x].firstElementChild}
                                var end = {'0': objTr[x].lastElementChild}
                                setSelectedCells(start, end);
                            }
                        })

                }

                function colClick(el) {
                   var col = parseInt(el.attr('col-id'), 10),
                    colSelected = el.attr('col-selected');

                    var objTd = $element.find('td')
                    var start;
                    var end
                    objTd.each((x)=>{
                        if(objTd[x].parentElement.parentElement == el[0].parentElement.parentElement.parentElement 
                            && objTd[x].cellIndex == el[0].parentElement.cellIndex){
                            
                            //console.log("objTd[x]: ", objTd[x]);
                            if(!start)
                            start = {'0': objTd[x]}
                            end = {'0': objTd[x]}
                            }
                    })
                    if (colSelected === "true") {
                        //ele.addClass('hover-area');
                        el.attr('col-selected', false);
                    } else {
                        //ele.not('.eng-selected-item').addClass('hover-area');
                        el.attr('col-selected', true);
                    }
                     //setRangeArea(objTr[x].firstElementChild, objTr[x].lastElementChild);
                    setSelectedCells(start, end);

                }

                function selectAllTable(el, isSelected) {
                    var objTable = el[0].firstElementChild;

                        var start = {'0': objTable.firstElementChild.firstElementChild};
                        var end = {'0': objTable.lastElementChild.lastElementChild};
                        
                        if (!isSelected) {
                            //$element.find('td').addClass('hover-area');
                            el.attr('select-all', false);
                        } else {
                            //$element.find('td').not('.eng-selected-item').addClass('hover-area');
                            el.attr('select-all', true);
                        }
    
                        setSelectedCells(start, end);
                }

                function clearAll(){
                    let ele = angular.element('.canvas').find('.eng-selected-item');
    
                    if(ele.length){
                        for(var i=0; i< ele.length; i++ ){
                            ele.removeClass('eng-selected-item');
                        }
                    }
                    
                    // resetting the values on control selection
                    $scope.multiCellIds = [];
                    $scope.resetCells = false
                }

                /**
                 * Wrap function
                 *
                 * @param      {Function}  fn      The function
                 * @return     {<Function>}    { event function }
                 */
                function wrap(fn, withShift = true) {
                    return function (event) {
                        //event.stopPropagation();

                        if (event.shiftKey != withShift) {
                            return;
                        }
                        var el = angular.element(this);
                        $scope.$apply(function () {
                            fn(el);
                        });
                        
                        if(fn == clearAll){
                            $scope.$apply(function () {
                                fn();
                            });
                        }else{
                            var el = angular.element(this);
                            if(el[0].offsetParent.classList.contains("selected") || el[0].offsetParent.offsetParent.classList.contains("selected"))
                            {
                                $scope.$apply(function () {
                                    fn(el);
                                });
                            }
                        }
                    }
                }

                $element.delegate('td', 'mousedown', wrap(mouseDown));
                $element.delegate('td', 'mouseenter', wrap(mouseEnter));
                $element.delegate('td', 'mouseleave', wrap(mouseLeave));
                $element.delegate('td', 'mouseup', wrap(mouseUp));
                $element.delegate('.row-selector-handler', 'click', wrap(rowClick, false));
                $element.delegate('.column-selector-handler', 'click', wrap(colClick, false));
                $element.delegate('.table-select-all', 'click', wrap(selectAllTable, false));
                $element.delegate('.column', 'click', wrap(clearAll, false));
                $scope.$watch('selectAll', function (scope) {
                    selectAllTable($element, $scope.selectAll);
                });
            }]

        }
    }]).name;



// WEBPACK FOOTER //
// ./client/components/multiCellSelect/multiCellSelect.directive.ts